export var FileUploadStatusMessage;
(function (FileUploadStatusMessage) {
    FileUploadStatusMessage["UPLOAD_FAILED_MESSAGE"] = "Upload(s) Failed";
    FileUploadStatusMessage["UPLOAD_FAILED_FILE_SIZE_MESSAGE"] = "Upload failed - file too large";
    FileUploadStatusMessage["UPLOAD_FAILED_FILE_NAME_LIMIT_MESSAGE"] = "Upload failed - file name too long";
    FileUploadStatusMessage["UPLOAD_FAILED_INVALID_FILE_TYPE_MESSAGE"] = "Upload failed - invalid file type";
    FileUploadStatusMessage["UPLOAD_FAILED_VIDEO_FILE_SIZE_MESSAGE"] = "Upload failed - video file too large";
    FileUploadStatusMessage["UPLOAD_FAILED_VIDEO_CUSTOM_MESSAGE"] = "Unable to upload .xxx file. The insurance carrier does not support video. Please contact the carrier.";
})(FileUploadStatusMessage || (FileUploadStatusMessage = {}));
//# sourceMappingURL=FileUploadStatusMessage.js.map